import axios from "../axios-auth";
import orginal_axios from "axios"

export const stockService = {
    getBinStocks,
    getStockList,
    getAllStockList,
    getDetailList,
    getAllDetailList,
    exportStockBalanceExcel,
    exportAllStockBalanceExcel,
    getAllStockValuationReport,
    getStockValuationReport,
    exportStockValuationExcel,
    getStockValuationReportSummary,
    getMonthlyStockAnalysisReport,
    getAllMonthlyStockAnalysisReport,
    getMonthlyStockAnalysisReportByCustomer,
    getAllMonthlyStockAnalysisReportByCustomer,
    getAllMonthlyStockAnalysisReportByCity,
    getMonthlyStockAnalysisReportByCity,
    getBatchListAndQcList,
    getStockBalanceSummaryList,
    getStockBalanceSummaryPrint,
    exportStockBalanceSummaryReportExcel,
    getStockQcBatchDateList,
};
function getBinStocks(searchParams) {
    let params = {
    };
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    return axios.get("/auth/bin-stock-balances", { params });
}

function getAllDetailList(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.type) {
        params["type"] = searchParams.type;
    }
    if (searchParams.productId) {
        params["productId"] = searchParams.productId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.binIds) {
        params["binIds"] = searchParams.binIds;
    }

    return axios.get("/auth/stock-balances-detail-summary", { params });
}
function getStockList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId.join();
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.binId) {
        params["binId"] = searchParams.binId;
    }
    if (searchParams.balanceType) {
        params["balanceType"] = searchParams.balanceType;
    }
    if (searchParams.stockLevelType) {
        params["stockLevelType"] = searchParams.stockLevelType;
    }
    if (searchParams.binIds) {
        params["binIds"] = searchParams.binIds.join();
    }
    return axios.get("/auth/bin-stock-balances", { params });
}

function getStockBalanceSummaryList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.warehouseIds) {
        params["warehouseIds"] = searchParams.warehouseIds.join();
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.binId) {
        params["binId"] = searchParams.binId;
    }
    if (searchParams.balanceType) {
        params["balanceType"] = searchParams.balanceType;
    }
    if (searchParams.stockLevelType) {
        params["stockLevelType"] = searchParams.stockLevelType;
    }
    if (searchParams.binIds) {
        params["binIds"] = searchParams.binIds.join();
    }
    return axios.get("/auth/bin-stock-balance-summary", { params });
}

function getStockBalanceSummaryPrint(searchParams) {
    let params = {
        sort: "w.name,asc"
    };
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.warehouseIds) {
        params["warehouseIds"] = searchParams.warehouseIds.join();
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.binId) {
        params["binId"] = searchParams.binId;
    }
    if (searchParams.balanceType) {
        params["balanceType"] = searchParams.balanceType;
    }
    if (searchParams.stockLevelType) {
        params["stockLevelType"] = searchParams.stockLevelType;
    }
    if (searchParams.binIds) {
        params["binIds"] = searchParams.binIds.join();
    }
    return axios.get("/auth/bin-stock-balances-summary-print", { params });
}

function exportStockBalanceSummaryReportExcel(searchParams, sortedBy) {
    let params = {
        sort: sortedBy
    };

    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.warehouseIds) {
        params["warehouseIds"] = searchParams.warehouseIds.join();
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.binId) {
        params["binId"] = searchParams.binId;
    }
    if (searchParams.balanceType) {
        params["balanceType"] = searchParams.balanceType;
    }
    if (searchParams.stockLevelType) {
        params["stockLevelType"] = searchParams.stockLevelType;
    }
    if (searchParams.binIds) {
        params["binIds"] = searchParams.binIds.join();
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/export-bin-stock-balance-summary-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getAllStockList(searchParams) {
    let params = {
        sort: "updatedDate,asc"
    };
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId.join();
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.binId) {
        params["binId"] = searchParams.binId;
    }
    if (searchParams.balanceType) {
        params["balanceType"] = searchParams.balanceType;
    }
    if (searchParams.stockLevelType) {
        params["stockLevelType"] = searchParams.stockLevelType;
    }
    if (searchParams.binIds) {
        params["binIds"] = searchParams.binIds.join();
    }
    return axios.get("/auth/bin-stock-balances-print", { params });
}

function getDetailList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.type) {
        params["type"] = searchParams.type;
    }
    if (searchParams.productId) {
        params["productId"] = searchParams.productId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.binIds) {
        params["binIds"] = searchParams.binIds;
    }
    if (searchParams.qcNo) {
        params["qcNo"] = searchParams.qcNo;
    }
    if (searchParams.batchNo) {
        params["batchNo"] = searchParams.batchNo;
    }
    return axios.get("/auth/stock-balances-detail-summary/", { params });
}

function exportStockBalanceExcel(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.type) {
        params["type"] = searchParams.type;
    }
    if (searchParams.productId) {
        params["productId"] = searchParams.productId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.binIds) {
        params["binIds"] = searchParams.binIds;
    }
    if (searchParams.qcNo) {
        params["qcNo"] = searchParams.qcNo;
    }
    if (searchParams.batchNo) {
        params["batchNo"] = searchParams.batchNo;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stock-balances-detail-excel", params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}


function exportAllStockBalanceExcel(searchParams) {
    let params = {};

    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId.join();
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.binId) {
        params["binId"] = searchParams.binId;
    }
    if (searchParams.balanceType) {
        params["balanceType"] = searchParams.balanceType;
    }
    if (searchParams.stockLevelType) {
        params["stockLevelType"] = searchParams.stockLevelType;
    }
    if (searchParams.binIds) {
        params["binIds"] = searchParams.binIds.join();
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stock-balances-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}


function getStockValuationReport(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.priceType) {
        params["priceType"] = searchParams.priceType;
    }
    if (searchParams.balanceType) {
        params["balanceType"] = searchParams.balanceType;
    }
    return axios.get("/auth/stock-valuation-report", { params });
}

function getStockValuationReportSummary(searchParams) {
    let params = {
    };

    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.priceType) {
        params["priceType"] = searchParams.priceType;
    }
    if (searchParams.balanceType) {
        params["balanceType"] = searchParams.balanceType;
    }
    return axios.get("/auth/stock-valuation-report-summary", { params });
}

function getAllStockValuationReport(searchParams) {
    let params = {
    };

    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.priceType) {
        params["priceType"] = searchParams.priceType;
    }
    if (searchParams.balanceType) {
        params["balanceType"] = searchParams.balanceType;
    }
    return axios.get("/auth/stock-valuation-report-print", { params });
}

function exportStockValuationExcel(searchParams) {
    let params = {
    };
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.priceType) {
        params["priceType"] = searchParams.priceType;
    }
    if (searchParams.balanceType) {
        params["balanceType"] = searchParams.balanceType;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stock-valuation-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getMonthlyStockAnalysisReport(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }
    if (searchParams.categoryIds) {
        params["categoryIds"] = searchParams.categoryIds.join();
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    return axios.get("/auth/monthly-stock-analysis-report", { params });
}

function getAllMonthlyStockAnalysisReport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }
    if (searchParams.categoryIds) {
        params["categoryIds"] = searchParams.categoryIds.join();
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    return axios.get("/auth/all-monthly-stock-analysis-report", { params });
}

function getMonthlyStockAnalysisReportByCustomer(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }
    if (searchParams.cityIds) {
        params["cityIds"] = searchParams.cityIds.join();
    }
    if (searchParams.categoryIds) {
        params["categoryIds"] = searchParams.categoryIds.join();
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return axios.get("/auth/monthly-stock-analysis-report-by-customer", { params });
}

function getAllMonthlyStockAnalysisReportByCustomer(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }
    if (searchParams.cityIds) {
        params["cityIds"] = searchParams.cityIds.join();
    }
    if (searchParams.categoryIds) {
        params["categoryIds"] = searchParams.categoryIds.join();
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    return axios.get("/auth/print-all-monthly-stock-analysis-report-by-customer", { params });
}

function getAllMonthlyStockAnalysisReportByCity(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }
    if (searchParams.cityIds) {
        params["cityIds"] = searchParams.cityIds.join();
    }
    if (searchParams.categoryIds) {
        params["categoryIds"] = searchParams.categoryIds.join();
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    return axios.get("/auth/print-all-monthly-stock-analysis-report-by-city", { params });
}

function getMonthlyStockAnalysisReportByCity(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }
    if (searchParams.cityIds) {
        params["cityIds"] = searchParams.cityIds.join();
    }
    if (searchParams.categoryIds) {
        params["categoryIds"] = searchParams.categoryIds.join();
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    return axios.get("/auth/monthly-stock-analysis-report-by-city", { params });
}

function getBatchListAndQcList(searchParams) {
    let params = {};
    if (searchParams.productId) {
        params['productId'] = searchParams.productId;
    }
    if (searchParams.binId) {
        params['binId'] = searchParams.binId;
    }
    return axios.get('/auth/exist-stock-batch-and-qc-list', { params });
}

function getStockQcBatchDateList(searchParams) {
    let params = {};

    if (searchParams.productId) {
        params["productId"] = searchParams.productId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.binId) {
        params["binId"] = searchParams.binId;
    }
    if (searchParams.balanceType) {
        params["balanceType"] = searchParams.balanceType;
    }

    return axios.get('/auth/product-stock-qc-batch-date-list', { params });
}